<template lang="pug">
  div.optimal-layout__col
    h2.optimal-layout__col_title Определение оптимального расположения объекта обращения с отходами
    form(
      @submit.prevent="onFormSubmit"
    )
      div.col
        .form__elem
          p.form__elem_label Тип объекта
          e-select.form__elem_input(
            :model="field"
            name="type"
            placeholder=""
            :options="paramsList"
          )
        .form__elem
          p.form__elem_label Мин.мощность (тонн в год)*
          e-input.form__elem_input(
            name="total"
            inputType="input"
            :model="field"
          )
        .form__elem
          p.form__elem_label Год*
          e-select.form__elem_input(
            :model="field"
            name="year"
            placeholder=""
            :options="yearOptions"
          )
        .form__elem
          button.form-elem__btn(
            type="submit"
          ) Разместить
        .form__elem.form__elem_margin-bottom
          p.form__elem_label Географические координаты
          e-input.form__elem_input(
            name="coords"
            inputType="input"
            :model="field"
            :disabled="true"
          )
        .form__elem
          div(
            ref="map"
            style='height: 300px; width: 100%; z-index: 9; position: relative;'
          )
</template>

<script>
  import 'leaflet';
  import 'leaflet.markercluster';
  import 'leaflet/dist/leaflet.css';
  import 'leaflet.markercluster/dist/MarkerCluster.css';
  import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

  import {threads} from "@/api/api-endpoints";
  import axios from "axios";
  import optimalLayoutMixin from "@/app/access/mixins/optimal-layout-mixin";

  export default {
    data() {
      return {
        field: {
          total: '',
          minPower: '',
          year: '',
          coords: '',
        },
        markerCoords: {},
      }
    },
    mixins: [optimalLayoutMixin],
    props: {
      yearOptions: {
        type: Array,
        default: () => []
      },
      parametersList: {
        type: Array,
        default: () => []
      },
      mapCenter: {
        type: Object,
        default: () => ({}),
      }
    },
    methods: {
      async onFormSubmit() {
        await this.getOptimalCoords(this.field)
      },
      async getOptimalCoords(field) {
        const {total, year} = field;
        if (!total || !year) {
          this.$e.errorBox('Заполните обязательные поля!');
          return;
        }
        const params = {total, year}
        const url = threads.optimalCoords();
        axios.get(url, {params})
          .then(response => (this.setCoords(response.data)));
      },
    },
  }
</script>
